<template>
  <div>
    <v-autocomplete
      v-model="value.raisonDuRetrait"
      :item-text="itemText"
      :item-value="itemValue"
      :items="listeRaisonsDuRetrait"
      :label="libelleRessource('DE-LBL-RAISON', 'Raison du retrait')"
      :rules="rules.raisonDuRetrait"
      required
      return-object
    ></v-autocomplete>

    <v-autocomplete
      v-model="value.reinscriptionPrevue"
      :item-text="itemText"
      :item-value="itemValue"
      :items="listeReinscriptionsPrevues"
      :label="libelleRessource('DE-LBL-REINSCRIPTION', 'Prévoyez-vous de vous réinscrire dans les 5 prochaines années ?')"
      :rules="rules.reinscriptionPrevue"
      required
      return-object
    ></v-autocomplete>

    <v-textarea
      v-model="value.precisionRetrait"
      :label="libelleRessource('DE-LBL-PRECISION', `Précision (s'il y a lieu)`)"
      auto-grow
      rows="2"
    ></v-textarea>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import LibelleRessource from "@/mixins/libelleRessource"

export default {
  mixins: [LibelleRessource],
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: {
        raisonDuRetrait: [(v) => !!v || "La raison du retrait est requise"],
        reinscriptionPrevue: [(v) => !!v || "Ce champ est requis"],
      },
    }
  },
  computed: {
    ...mapGetters({
      listeRaisonsDuRetrait: "Catalogue/getRaisonsDuRetrait",
      listeReinscriptionsPrevues: "Catalogue/getReinscriptionsPrevues",
    }),
  },
  created() {
    this.getCatalogue(this.$cataloguesDesc.raisonDuRetrait)
    this.getCatalogue(this.$cataloguesDesc.reinscriptionPrevue)
  },
  methods: {
    ...mapActions({
      getCatalogue: "Catalogue/getCatalogue",
    }),
    itemText: (item) => item.lang00,
    itemValue: (item) => item.id,
  },
}
</script>

<style></style>
